import URL from "../URL"

export default function mailToUrl({to, ...mail}) {
	return `mailto:${to || ''}?${URL.Params.encode(mail)}`;
}